
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Pimplesaugartomumbaicab() {



    const cardData =
    {
        keyword: 'Pimple Saudagar to Mumbai Cab Service',
        heading: 'Meghana Cab : Pimple Saudagar to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Pimple Saudagar to Mumbai Cab Service, ensuring a smooth, safe, and comfortable travel experience from one of Pune’s rapidly developing residential areas to the city of Mumbai. Whether you are planning a business trip, family outing, or airport transfer, our fleet of well-maintained Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers caters to every travel need. Enjoy doorstep pickup from Pimple Saudagar, experienced drivers, on-time service, transparent pricing, and 24/7 customer support. Book your Pimple Saudagar to Mumbai Cab with Meghana Cab for a hassle-free and reliable intercity journey.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

     "services": [
    {
      "name": "Pimple Saudagar to Mumbai Taxi Booking",
      "description": "Easily book your taxi from Pimple Saudagar to Mumbai with our streamlined online platform. Enjoy hassle-free reservations, multiple vehicle options, and prompt confirmation to start your journey without delays."
    },
    {
      "name": "One Way Cab Pimple Saudagar to Mumbai",
      "description": "Opt for our reliable one-way cab service from Pimple Saudagar to Mumbai for quick, direct transfers. Perfect for solo travelers or small groups seeking comfort and punctuality on this route."
    },
    {
      "name": "Round Trip Cab Pimple Saudagar to Mumbai",
      "description": "Plan your round trip journey between Pimple Saudagar and Mumbai with ease. Benefit from cost-effective packages, guaranteed cab availability, and dedicated drivers for both onward and return trips."
    },
    {
      "name": "Online Cab Booking Pimple Saudagar to Mumbai",
      "description": "Secure your cab instantly through our online booking system. Choose from sedans, SUVs, and more, all at transparent prices with real-time availability for your Pimple Saudagar to Mumbai travel."
    },
    {
      "name": "Budget Taxi Pimple Saudagar to Mumbai",
      "description": "Travel affordably without compromising quality. Our budget taxi options from Pimple Saudagar to Mumbai offer clean vehicles, professional drivers, and excellent service at economical rates."
    },
    {
      "name": "SUV Cab Hire Pimple Saudagar to Mumbai",
      "description": "Hire a spacious and comfortable SUV cab for your journey from Pimple Saudagar to Mumbai. Ideal for families or groups requiring extra luggage space and luxury on the road."
    },
    {
      "name": "AC Sedan Pimple Saudagar to Mumbai",
      "description": "Enjoy a cool and comfortable ride with our air-conditioned sedan cabs, perfect for business or leisure travel between Pimple Saudagar and Mumbai."
    },
    {
      "name": "Chauffeur Driven Taxi Pimple Saudagar to Mumbai",
      "description": "Experience professional chauffeur-driven taxi services for a stress-free trip. Our trained drivers ensure safety, punctuality, and personalized service throughout your journey."
    },
    {
      "name": "Family Trip Cab Pimple Saudagar to Mumbai",
      "description": "Make family travels smooth and enjoyable with our spacious, safe, and comfortable cabs designed for group comfort from Pimple Saudagar to Mumbai."
    },
    {
      "name": "Private Cab Pimple Saudagar to Mumbai",
      "description": "Travel exclusively in a private cab with no stops or detours. Ideal for travelers valuing privacy, time-efficiency, and a tailored journey between Pimple Saudagar and Mumbai."
    },
    {
      "name": "Business Travel Pimple Saudagar to Mumbai",
      "description": "Efficient and reliable cab services tailored for business professionals traveling between Pimple Saudagar and Mumbai. Focus on your work while we handle your transport needs."
    },
    {
      "name": "Reliable Cab Pimple Saudagar to Mumbai",
      "description": "Count on our reliable cab services with timely pickups, well-maintained vehicles, and courteous drivers, ensuring a hassle-free experience from Pimple Saudagar to Mumbai."
    },
    {
      "name": "Fast Booking Pimple Saudagar to Mumbai",
      "description": "Book your taxi swiftly with our fast booking system, designed to allocate the nearest available cab and minimize wait times for your Pimple Saudagar to Mumbai trip."
    },
    {
      "name": "24/7 Service Pimple Saudagar to Mumbai",
      "description": "Avail round-the-clock taxi service from Pimple Saudagar to Mumbai. No matter the hour, we are ready to provide safe and reliable transport for your convenience."
    },
    {
      "name": "Comfortable Cab Pimple Saudagar to Mumbai",
      "description": "Travel in comfort with our well-equipped cabs featuring plush seating, climate control, and smooth rides, making your Pimple Saudagar to Mumbai journey relaxing and enjoyable."
    }
  ],
  "tableData": [
    ["Pimple Saudagar to Mumbai Taxi Booking", "One Way Cab Pimple Saudagar to Mumbai"],
    ["Round Trip Cab Pimple Saudagar to Mumbai", "Online Cab Booking Pimple Saudagar to Mumbai"],
    ["Budget Taxi Pimple Saudagar to Mumbai", "SUV Cab Hire Pimple Saudagar to Mumbai"],
    ["AC Sedan Pimple Saudagar to Mumbai", "Chauffeur Driven Taxi Pimple Saudagar to Mumbai"],
    ["Family Trip Cab Pimple Saudagar to Mumbai", "Private Cab Pimple Saudagar to Mumbai"],
    ["Business Travel Pimple Saudagar to Mumbai", "Reliable Cab Pimple Saudagar to Mumbai"],
    ["Fast Booking Pimple Saudagar to Mumbai", "24/7 Service Pimple Saudagar to Mumbai"],
    ["Comfortable Cab Pimple Saudagar to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Reliable Pimple Saudagar to Mumbai Cab Service",
        "WhyChoosedescription": "Our cab service from Pimple Saudagar to Mumbai offers a dependable and smooth travel experience. Whether you're commuting for work, heading to the airport, or planning a family outing, we ensure on-time pickups, a comfortable ride, and a stress-free journey every time."
    },
    {
        "WhyChooseheading": "Well-Maintained, Clean, and Air-Conditioned Vehicles",
        "WhyChoosedescription": "Choose from our fleet of well-maintained sedans, SUVs, and premium cars—each equipped with comfortable seating, air conditioning, and plenty of luggage space. Every vehicle is sanitized before every trip to provide you with a safe and clean travel environment."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our courteous, experienced drivers are familiar with the Pimple Saudagar–Mumbai route and always follow the safest and fastest paths. They ensure a smooth ride while maintaining high standards of professionalism, safety, and customer service."
    },
    {
        "WhyChooseheading": "Transparent, All-Inclusive Pricing with No Hidden Charges",
        "WhyChoosedescription": "We believe in upfront pricing—your fare includes all essential charges such as fuel, tolls, taxes, and driver allowance. There are no surprise costs, so you can travel with complete confidence and budget clarity."
    },
    {
        "WhyChooseheading": "Flexible Travel Options to Match Your Schedule",
        "WhyChoosedescription": "Whether you’re booking a one-way trip, return journey, or hourly rental, we provide flexible booking options to suit your travel plans. Customize your pickup and drop-off times and locations as per your convenience."
    },
    {
        "WhyChooseheading": "Door-to-Door Service for Complete Convenience",
        "WhyChoosedescription": "We offer true door-to-door cab service—our driver will pick you up from your location in Pimple Saudagar and drop you at any destination in Mumbai, whether it’s your office, hotel, airport, or a residential address."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Business Travel, and Weekend Trips",
        "WhyChoosedescription": "Our cab service is perfect for airport drop-offs, client meetings, or weekend trips to Mumbai. Travel in comfort with enough space for your luggage and personalized service that fits the purpose of your journey."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Book your ride any time of day or night with our easy online booking system or by contacting our customer support team. We’re available 24/7 to help with booking changes, last-minute requests, and trip updates."
    }
]











    }

const faqData = [
    {
        question: "How do I book a cab from Pimple Saudagar to Mumbai?",
        answer: "You can easily book by calling Meghana Cab at +91 9075462128 or through our website for quick online booking."
    },
    {
        question: "What is the typical travel time from Pimple Saudagar to Mumbai by cab?",
        answer: "The journey usually takes around 3 to 4 hours depending on traffic and route."
    },
    {
        question: "Are one way and round trip cab services available from Pimple Saudagar to Mumbai?",
        answer: "Yes, we offer flexible one way and round trip options for your convenience."
    },
    {
        question: "What types of vehicles are offered for this route?",
        answer: "We have hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers available."
    },
    {
        question: "Is the cab service from Pimple Saudagar to Mumbai available 24/7?",
        answer: "Yes, Meghana Cab operates round the clock to serve you anytime."
    },
    {
        question: "What does the fare cover for this cab service?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I book a cab on short notice from Pimple Saudagar to Mumbai?",
        answer: "Yes, last-minute bookings are accepted based on vehicle availability. Calling directly helps quick confirmation."
    },
    {
        question: "Is online booking and payment available for this service?",
        answer: "Yes, you can book and pay securely online using multiple payment methods."
    },
    {
        question: "Can I request stops for meals or rest during the trip?",
        answer: "Yes, stopovers can be arranged upon request. Please inform us when booking or notify the driver."
    },
    {
        question: "Are the drivers experienced on the Pimple Saudagar to Mumbai route?",
        answer: "Absolutely. Our drivers are professional, trained, and familiar with the best routes."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Saurabh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very comfortable and reliable cab service from Pimple Saudagar to Mumbai. The driver was friendly and punctual.”',
    },
    {
        name: 'Ms. Kavita Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booking was simple and hassle-free. Clean car and smooth ride with Meghana Cab.”',
    },
];

































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimple Saudagar to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pimple-saudagar-to-mumbai-cab.jpg",
  "description": "Book reliable and comfortable cab service from Pimple Saudagar to Mumbai with Meghana Cabs. Choose from budget, SUV, AC sedan, and chauffeur-driven taxis for one-way and round trips. Available 24/7 with fast online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1850",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pimple-saudagar-to-mumbai-cab-service"
  }
};







    return (
        <div>
<Helmet>
  <title>Pimple Saudagar to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable and comfortable cab service from Pimple Saudagar to Mumbai with Meghana Cabs. Choose from budget, SUV, AC sedan, and chauffeur-driven taxis for one-way and round trips. Available 24/7 with fast online booking." 
  />
  <meta 
    name="keywords" 
    content="Pimple Saudagar to Mumbai Taxi Booking, One Way Cab Pimple Saudagar to Mumbai, Round Trip Cab Pimple Saudagar to Mumbai, Online Cab Booking Pimple Saudagar to Mumbai, Budget Taxi Pimple Saudagar to Mumbai, SUV Cab Hire Pimple Saudagar to Mumbai, AC Sedan Pimple Saudagar to Mumbai, Chauffeur Driven Taxi Pimple Saudagar to Mumbai, Family Trip Cab Pimple Saudagar to Mumbai, Private Cab Pimple Saudagar to Mumbai, Business Travel Pimple Saudagar to Mumbai, Reliable Cab Pimple Saudagar to Mumbai, Fast Booking Pimple Saudagar to Mumbai, 24/7 Service Pimple Saudagar to Mumbai, Comfortable Cab Pimple Saudagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pimplesaugartomumbaicab;